import axios from "../http_v2";

export default {
  page(params) {
    return axios.get("activityservice/video/subject/page", params);
  },
  save(params) {
    return axios.post("activityservice/video/subject/save", params);
  },
  del(params) {
    return axios.get("activityservice/video/subject/delete/id", params);
  }
};
